import { NgModule } from '@angular/core';

import { ChartjsComponent } from './chartjs.component';
import * as ChartLabel from 'chartjs-plugin-datalabels';
import * as DoughnutLabel from 'chartjs-plugin-doughnutlabel';

@NgModule({
  exports: [ChartjsComponent],
  declarations: [ChartjsComponent],
})
export class ChartjsModule {
  // chartLabel = new ChartLabel();
  // doughnutLabel = new DoughnutLabel();
}
